export const IS_FAILED = 'failed';
export const IS_LOADING = 'loading';
export const IS_SUCCEEDED = 'succeeded';
